import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { ZendeskArticle, ZendeskCategory } from 'interfaces/ZendeskArticle';

import { useContent } from 'hooks/queries/useContent';
import { NotFound } from 'components/app/NotFound';
import CenteredCircularProgress from 'components/page/CenteredCircularProgress';

import ArticleContainer from './ArticleContainer';
import CategoryContainer from './CategoryContainer';

// The API only ever resolves on the final segment of an address — everything before it
// is breadcrumb context, not part of the lookup.
const lastSegment = (splat?: string): string => {
  const segments = (splat ?? '').split('/').filter(Boolean);
  return segments[segments.length - 1] ?? '';
};

const ContentPage: FC = () => {
  const params = useParams();
  const content = lastSegment(params['*']);

  const { data, isLoading, error } = useContent(content);

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  if (error || !data) {
    return <NotFound />;
  }

  return data.type === 'article' ? (
    <ArticleContainer article={data.data as ZendeskArticle} />
  ) : (
    <CategoryContainer category={data.data as ZendeskCategory} />
  );
};

export default ContentPage;
